import request from '@/utils/request'
import requestWx from '@/utils/requestWx'

export const glb = (id: number, file_type: string,isShare: string, extParams?: any) => {
    return request('model/glb', {
        method: 'GET',
        params: Object.assign({}, {
            file_type,
            s: isShare,
            id,
            type: 1,
            without_head: 1,
        }, extParams),
    })
}

export const get3dBgList = (pid: number) => {
    return request('material/bg', {
        method: 'GET',
        params: {
            pid,
        },
    })
}

export const getWechatConfig = (url: string) => {
    return requestWx('wechatConfig/config', {
        method: 'GET',
        data: {
            url: url.split('#')[0],
        },
    })
}
